import { FunctionComponent, MouseEvent } from 'react';
import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { getItemOffset } from '@nx-frontend/shared/store/feature-menu-tree';

interface MenuTreeItemEmptyProps {
  level: number;
  text?: string;
  hideAddButton?: boolean;
  isActive?: boolean;
  onMenuItemAdd?: (event: MouseEvent) => void;
  permissionPreviewEnabled?: boolean;
}

export const MenuTreeItemEmpty: FunctionComponent<MenuTreeItemEmptyProps> = ({
  level,
  text,
  hideAddButton = false,
  isActive = false,
  onMenuItemAdd,
  permissionPreviewEnabled,
}) => {
  const t = useTranslations('webnotes');
  const message = text ?? t('webnotes-no_content_yet');
  const paddingLeft = getItemOffset(level + 1, permissionPreviewEnabled);

  const handleAddClick = (event: MouseEvent) => {
    if (onMenuItemAdd) {
      onMenuItemAdd(event);
    }
  };

  return (
    <div
      style={{ paddingLeft }}
      className={classNames('flex items-center py-2 pr-4 text-xs text-neutral-500', { 'bg-cyan-100': isActive })}
    >
      <span className="whitespace-nowrap text-ellipsis overflow-hidden">{message}</span>
      {!hideAddButton && (
        <div className="ml-auto w-4 h-4 rounded hover:bg-neutral-200 cursor-pointer" onClick={handleAddClick}>
          <Icon icon={IconsMap.PLUS} className="text-neutral-500" />
        </div>
      )}
    </div>
  );
};
